import { useSelector } from "react-redux";
import { useGetDashboardQuery } from "../dashboard/dashboardApi";
import { selectAuth, selectIsAuthenticated } from "./authSlice";

/**
 * Single source of truth for "what can the current user see/do".
 * Backed by GET /dashboard, which returns the same roles/modules/permissions/
 * branches claims as login - refetched on app load so nav state rebuilds
 * without re-prompting for login (see handoff doc §5).
 */
export const useClaims = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const auth = useSelector(selectAuth);
  const { data, isLoading, isError } = useGetDashboardQuery(undefined, {
    skip: !isAuthenticated,
  });

  return {
    isAuthenticated,
    username: auth.username,
    fullName: auth.fullName,
    mustChangePassword: auth.mustChangePassword,
    isLoading: isAuthenticated && isLoading,
    isError,
    roles: data?.roles || [],
    modules: data?.modules || [],
    permissions: data?.permissions || [],
    branches: data?.branches || [],
    isAllBranches: Boolean(data?.isAllBranches),
  };
};

export const useHasPermission = (code) => {
  const { permissions } = useClaims();
  if (!code) return true;
  return permissions.includes(code);
};
